// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34LLn","right":"styles_right__RitFE"};